<template>
  <component
    class="site-menu-button"
    :is="href ? 'a' : 'div'"
    :href="href"
  >
    {{ label }}
  </component>
</template>

<script setup>
  const props = defineProps({
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      default: undefined
    }
  })
</script>

<style lang="scss" scoped>
  @use './index.scss';
</style>